import loadable from '../../../utilities/loadable'

export const InfoModal = loadable(() => import('./InfoModal'))
export const SplashScreen = loadable(() => import('./SplashScreen'))
